export default class SetLanguageClass {
  getShuttoLanguage() {
    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "getShuttoLanguage"
    });
  }

  setShuttoLanguage(languageTarget){
    window.dataLayer = window.dataLayer || [];

    const languageInfo = window.dataLayer.filter(function(data) {
      return data.event === 'shuttoLanguage';
    })

    if(languageInfo.length > 0){
      const language = languageInfo.pop().language;

      switch (language) {
        case "ja":
          languageTarget.value = 0
          break;
        case "en":
          languageTarget.value = 1
          break;
        default:
          languageTarget.value = 0
          break;
      }
    }
  }
}
